import Model  from "./base/model";

class AuditsOrderAdditionalService extends Model{
  resourceName() {
    return "audits_order_additional_services";
  }

  fields() {
    return {
      id: "",
      order_id: "",
      audit: "",
      result: ""
    }
  }

}

export default new AuditsOrderAdditionalService();

